import { render } from "./PDFViewer.vue?vue&type=template&id=d18a4dce&scoped=true"
import script from "./PDFViewer.vue?vue&type=script&lang=js"
export * from "./PDFViewer.vue?vue&type=script&lang=js"

import "./PDFViewer.vue?vue&type=style&index=0&id=d18a4dce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18a4dce"]])

export default __exports__